jQuery(document).ready(function ($) {

    if ( typeof affcoups_vars !== 'undefined' ) {

        // Quit if store is not known
        if ( affcoups_vars.hasOwnProperty('tracking') ) {
            //console.log('click_tracking activated');

            /**
             * Link Clicks
             */
            $('[data-affcoups-coupon-id] a, a[data-affcoups-coupon-id]').on( "click", function( event ) {

                // Debug
                //event.preventDefault();
                var container = getContainerFromElement( this );

                var redirectCouponPage = container.data('affcoups-redirect-coupon-page');

                if ( redirectCouponPage )
                    return;

                var couponId = getCouponIdFromContainer( container );

                //console.log('click_tracking >> couponId: ' + couponId );

                if ( ! couponId )
                    return;

                sendTrackingRecord( 'click', couponId );

            });

            /**
             * Clipboard Clicks
             */
            $('[data-affcoups-clipboard="true"]').on( "click", function( event ) {

                // Debug
                //event.preventDefault();

                // If clicked link has container attribute take it, otherwise search for the ancestor
                var container = getContainerFromElement( this );

                var couponId = getCouponIdFromContainer( container );

                //console.log('clipboard click >> couponId: ' + couponId );

                if ( ! couponId )
                    return;

                sendTrackingRecord( 'copy', couponId );

            });

            /**
             * Views
             */
            var coupons = $('[data-affcoups-coupon-id]');

            //console.log( 'coupons: ' + coupons.length );

            if ( coupons.length ) {

                var couponIds = [];

                coupons.each(function( index, obj ) {

                    var container = getContainerFromElement( obj );
                    var couponId = getCouponIdFromContainer( container );

                    couponIds.push( couponId );
                });

                //console.log( couponIds );

                if ( couponIds.length > 0 ) {
                    sendTrackingRecord( 'view', couponIds );
                }
            }

        }
    }

    /**
     * Get container from clicked element
     *
     * If clicked element has container attribute take it, otherwise search for the ancestor
     *
     * @param el
     * @returns {*}
     */
    function getContainerFromElement( el ) {
        return ( $( el ).attr('data-affcoups-coupon-id') ) ? $( el ) : $( el ).closest( '[data-affcoups-coupon-id]' );
    }

    /**
     * Get coupon id from container
     *
     * @param container
     * @returns {*}
     */
    function getCouponIdFromContainer( container ) {
        return container.data('affcoups-coupon-id');
    }

    /**
     * Send tracking record via AJAX to database
     * @param type
     * @param couponId
     */
    function sendTrackingRecord( type, couponId ) {

        // Request
        jQuery.ajax({
            url : affcoups_post.ajax_url,
            type : 'post',
            data : {
                action : 'affcoups_pro_tracking_action',
                type: type,
                coupon_id : couponId,
                url : window.location.href
            },
            success : function( response ) {
                //console.log('Response: ' + response);
            }

        });
    }

});